var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeCloseRed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5265_28215)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.00016 3.79166C8.61016 3.79166 9.91683 5.09832 9.91683 6.70832C9.91683 7.00582 9.8585 7.29166 9.77683 7.55999L11.5618 9.34499C12.3727 8.62749 13.0143 7.72916 13.4168 6.70249C12.4077 4.14749 9.91683 2.33332 7.00016 2.33332C6.25933 2.33332 5.54766 2.44999 4.87683 2.66582L6.14266 3.93166C6.41683 3.84999 6.70266 3.79166 7.00016 3.79166ZM1.581 1.84332C1.3535 2.07082 1.3535 2.43832 1.581 2.66582L2.73016 3.81499C1.78516 4.56749 1.03266 5.55916 0.583496 6.70832C1.59266 9.26916 4.0835 11.0833 7.00016 11.0833C7.88683 11.0833 8.73266 10.9083 9.51433 10.605L11.101 12.1917C11.3285 12.4192 11.696 12.4192 11.9235 12.1917C12.151 11.9642 12.151 11.5967 11.9235 11.3692L2.40933 1.84332C2.18183 1.61582 1.8085 1.61582 1.581 1.84332ZM7.00016 9.62499C5.39016 9.62499 4.0835 8.31832 4.0835 6.70832C4.0835 6.25916 4.1885 5.83332 4.36933 5.45999L5.28516 6.37582C5.26766 6.48082 5.25016 6.59166 5.25016 6.70832C5.25016 7.67666 6.03183 8.45832 7.00016 8.45832C7.11683 8.45832 7.22183 8.44082 7.33266 8.41749L8.2485 9.33332C7.86933 9.51999 7.44933 9.62499 7.00016 9.62499ZM8.73266 6.51582C8.64516 5.69916 8.0035 5.06332 7.19266 4.97582L8.73266 6.51582Z",
    fill: "#FF4D4F",
    fillOpacity: 0.45
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5265_28215"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeCloseRed);
export default __webpack_public_path__ + "static/media/eye-close-red.c382ae7b37f0095179514682ad96eb5e.svg";
export { ForwardRef as ReactComponent };